import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { AccountFormValues } from "src/models/Account.model";
import { useAddAccountMutation } from "src/services/AccountServices";
import { showToast } from "src/utils/showToaster";
import { array, object, string } from "yup";
import AccountForm from "../Layouts/AccountForm";

type Props = {
  onClose: () => void;
};

const AddAccountFormWrapper = ({ onClose }: Props) => {
  const [addAccount] = useAddAccountMutation();

  // Form Initial Values
  const initialValues: AccountFormValues = {
    accountName: "",
    openingBalance: "0",
    forAllBranches: false,
    branches: [],
    accountDetails: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    accountName: string().required("Please enter account name"),
    accountDetails: string().required("Please enter account details"),
    branches:array().test("branchTest","Please select branch",(value,context)=>{
      const {forAllBranches} = context.parent
      return !forAllBranches ? (value && value?.length!==0) : true
    })
  });

  // Handle Submit
  const handleSubmit = (
    values: AccountFormValues,
    { setSubmitting, resetForm }: FormikHelpers<AccountFormValues>
  ) => {
    const formattedValues = {
      accountName: values.accountName,
      openingBalance: values.openingBalance,
      branchId: values?.forAllBranches ? [] : values?.branches?.map((branch) => branch?.value),
      accountDetails: values.accountDetails,
      allBranches : values.forAllBranches,
    };

    addAccount(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <AccountForm formikProps={formikProps} onClose={onClose} formType="Add" />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddAccountFormWrapper;
